const styles = {
  buttonsContainer: {
    display: 'flex',
    flex: 1,
  },
  buttonsColumnContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    alignItems: 'center',
    flex: 1,
  },
  buttonContainer: {
    width: '8em',
    margin: '10px 0px',
  },
};

export default styles;
